<template>
    <div>

        <div class="page-loading" v-if="init === true">
            <Title title="" :path="formPath" />
            <van-skeleton title :row="8" />
        </div>
        <template v-else>
            <Title :path="formPath" :title="tabs[0]" v-if="expert.isExpert === true" :tablist="tabs" :tabactive="tab_active" @titleTabActive="titleTabActive"/>
            <Title :path="formPath" :title="tabs[0]" v-else/>

            <div v-if="tab_active === 0 && match" :class="['detail-main', expert.isExpert===false?'detail-main-free':'']">
                <div class="detailtb">
<!--                    <div class="fan" v-if="match.isRetreat">返还</div>-->
<!--                    <div class="yiding" v-else-if="match.isConsume">已订</div>-->
                    <div class="item hd">
                            <span class="tp" :style="'color:'+ match.color ">{{ match.match_type }}</span>
                            <span class="tp">{{ match.start }}</span>
                            <span class="desc" v-if="match.tjtype===2 && match.match_desc">{{ match.match_desc }}</span>
                    </div>
                    <div class="item">
                            <div class="duiz">
                                <span class="dz sp">{{ match.shangpan }}</span>
                                <span class="pk">
                                    <em>{{ match.pankou }}</em>
                                        <i v-if="match.dxq">大小球</i>
                                        <i v-else>让球</i>
                                </span>
                                <span class="dz xp">{{ match.xiapan }}</span>
                            </div>
                    </div>
                    <div class="item" v-if="match.bifen !== '-'">
                            <div class="bf">
                                <span class="bf1">{{ match.bf1 }}</span>
                                <i>比分</i>
                                <span class="bf2">{{ match.bf2 }}</span>
                            </div>
                    </div>
                    <div class="item" v-if="match.tjtype === 1">
                        <div class="tui"><span>荐<i></i></span>{{ match.commend }}</div>
                        <span :class="'rs rs'+match.result_id">{{ match.result }}</span>
                    </div>
                    <div class="fxboex tebbuy" v-else>
                            <div class="price">
                                <template v-if="match.dian != match.dian0">
                                <div class="sell zhekou"><i>现售</i><span>{{ match.dian }}<em>FXB</em></span></div>
                                <div class="sell yuan"><i>原售</i><span>{{ match.dian0 }}<em>FXB</em></span></div>
                                </template>
                                <div class="sell selldu" v-else><i>现售</i><span>{{ match.dian }}<em>FXB</em></span></div>
                            </div>
                        <div class="dingy">
                            <button type="button" class="ding" v-if="match.tjtype === 2" @click="ding">立即订阅</button>
                            <button type="button" class="ding dingdis" title="不可订阅" v-else-if="match.tjtype === 3">立即订阅</button>
                            <template v-if="match.tjtype === 2">
                                <button type="button" class="ding cart" @click="addCart()" v-if="match.isCart === false">加入购物车</button>
                                <button type="button" class="ding dingdis" v-else>加入购物车</button>
                            </template>
                            <button type="button" class="ding dingdis" v-else-if="match.tjtype === 3">加入购物车</button>
                        </div>
                    </div>
                    <div class="item shengtme" v-if="match.tjtype !== 1">
                        <div class="title">订阅剩余</div>
                        <div :class="['shengsp', match.tjtype ===3?'shengsp_dis':'']" data-type="3">
                            {{match.sytime_text}}
                        </div>
                    </div>

                    <div class="det-shuo" v-if="match.isExpertCommend"><span><em>本站承诺</em>不中100%返还</span></div>
                    <div class="det-tips">
                        <div class="t">温馨提示</div>
                        <template v-if="match.isExpertCommend">
                            <div class="c"><em>1、</em><p>该预测仅作中国体育彩票竞彩参考，请勿用于非法用途，本站倡导理性购彩。</p></div>
                            <div class="c"><em>2、</em><p>订阅前请仔细阅读《<span @click="toTreaty">用户协议</span>》及《<span @click="toMianze">免责声明</span>》</p></div>
                        </template>
                        <template v-else>
                            <div class="c"><em>1、</em><p>登录会员每天“签到”领取积分可抵扣FXB订阅该精选预测。</p></div>
                            <div class="c"><em>2、</em><p>免费预测是通过收集网络上各高手心水而总结出的信息，具有一定的参考价值，但不保证胜率，请球友们勿盲目跟踪！</p></div>
                            <div class="c"><em>3、</em><p>该预测仅作中国体育彩票竞彩参考，请勿用于非法用途，本站倡导理性购彩。</p></div>
                            <div class="c"><em>4、</em><p>订阅前请仔细阅读《<span @click="toTreaty">用户协议</span>》及《<span @click="toMianze">免责声明</span>》</p></div>
                        </template>
                    </div>
                </div>
            </div>

            <div :class="['detail-main', 'detail-expert', match.tjtype === 1?'detail-nombtm':'', tab_active === 1?'detail-eombtm':'']" v-if="expert && expert.isExpert === true">
                <div class="det-exinfo">
                    <router-link :to="'/expert/'+expert.ename">
                        <div class="img"><img :src="expert.portrait"/></div>
                        <div class="con">
                            <div class="name">{{ expert.name }}<span>{{expert.ename}}</span></div>
                            <div class="remark" v-if="expert.desc">{{ expert.desc }}</div>
                        </div>
                    </router-link>
                </div>
                <div class="det-rate-title">专家胜率
                    <div class="fte" id="exratefte" data-st="2">
                        <span @click="getRate(1)" :class="expert_rate_sel===1?'curr':''">按天</span>
                        <span @click="getRate(2)" :class="expert_rate_sel===2?'curr':''">按场</span>
                        <span @click="getRate(3)" :class="expert_rate_sel===3?'curr':''">按月</span>
                    </div>
                </div>
                <div class="det-rate">
                    <ul v-if="winrate.length>0">
                        <li v-for="(c,i) in winrate" :key="i">
                            <div class="ct">
                                <span class="name">{{ c.name }}</span>
                                <div class="xq">
                                    <span class="sheng">{{ c.sheng }}</span>/<span class="ping">{{ c.ping }}</span>/<span class="fu">{{ c.fu }}</span>
                                </div>
                                <span class="result">{{ c.sl }}%</span>
                            </div>
                            <div class="line" ref="line"><div class="sline" :style="c.width"></div></div>
                        </li>
                    </ul>
                </div>
            </div>

            <template v-if="tab_active===1">
                <match_mini :data="match_list"/>
                <div class="panel_more panel_more_zj"><router-link :to="'/expert/'+expert.ename">更多专家预测 &gt;</router-link></div>
            </template>

        </template>

        <div class="fxcar" v-if="user">
            <span v-if="user.cart>0">{{user.cart}}</span>
            <router-link to="/cart"/>
        </div>

    </div>
</template>

<script>
    import match_mini from './public/match_mini'
    import Title from './public/title'
    import {mapGetters} from "vuex";
    export default {
        name: "match",
        computed: mapGetters(["dingSuccess", "user"]),
        components: {
            match_mini,
            Title
        },
        data() {
            return {
                match: null,
                match_list: {'type': 3, 'list': []},
                tabs: ['', '专家战绩'],
                tab_active: 0,
                mid: 1,
                winrate: [],
                expert: null,
                timer: null,
                expert_rate_sel: 1,
                formPath: '',
                init: true,
                times: [0,0,0,0,0,0]
            }
        },
        watch: {
            '$route': {
              handler: function () {
                  // console.log(this.$route.params.id)
                  // console.log(this.$route.meta.path)
                  if(this.$route.path.indexOf('/match')>-1){
                      this.tab_active = 0
                      this.mid = this.$route.params.id
                      if(this.mid) {
                          // this.match_list.list = []
                          this.init = true
                          // this.expert = null
                          this.getData()
                      }
                  }
              }
            },
            dingSuccess(v){
                let that = this
                // console.log(v)
                if(v!=='') {
                    let list = []
                    v.forEach(function (e) {
                        list.push(''+e.mid)
                    })
                    // console.log(list, that.mid)
                    if(list.indexOf(that.mid) > -1){
                        that.getData()
                    }
                }
            },
        },
        activated() {
            let that = this
            that.mid = that.$route.params.id
            // console.log(that.mid)
            this.tab_active = 0
            this.init = true
            this.expert = null
            that.getData()
        },
        methods: {
            titleTabActive(v){
                this.tab_active = v
                this.setlinewidth()
                this.$backTop()
            },
            getData(){
                let that = this
                that.$get(that.$api.match_view,{mid: that.mid, page: that.page})
                    .then(function (res) {
                        if(res.code === 1) {
                            let match_history = res.data.match_list
                            match_history.forEach(function (c) {
                                c.same_num = 0
                            })
                            that.match_list.list = match_history
                            that.match = res.data.match
                            that.expert = res.data.expert
                            that.winrate = res.data.winrate
                            if(res.data.winrate.length>0)
                                that.setlinewidth()
                            that.init = false

                            // console.log(that.expert)
                            if(that.expert.isExpert){
                                that.tabs[0] = '专家预测'
                            }
                            else {
                                if (that.expert.group === 1)
                                    that.tabs[0] = '足球精选'
                                else
                                    that.tabs[0] = '篮球精选'
                            }
                            that.$route.meta.title = that.tabs[0]
                            setTimeout(function () {
                                that.updateListDyStatus()
                            }, 0)
                            // that.match.sytime = 10
                        }
                    })
            },
            ding() {
                let that = this
                that.$post(that.$api.dingyue, {mid: that.mid}).then(function (res) {
                    if(res.code === 1){
                        that.$store.commit('SET_DING', res.data)
                    }
                    else
                        that.$toast.fail(res.msg)
                })
            },
            addCart: function () {
                let that = this
                that.$post(that.$api.addcart, {mid: that.match.mid}).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)

                        that.match.isCart = true
                        //更新存储数据
                        let userInfo = JSON.parse(localStorage.getItem('user'))
                        userInfo.cart += 1
                        that.$store.commit('SET_USER', userInfo)
                    }
                    else
                        that.$toast.fail(res.msg)
                })
            },
            getRate(t){
                let that = this
                that.expert_rate_sel = t
                that.$get(that.$api.expert_rate, {eid: that.expert.ename, type: t})
                    .then(function (res) {
                        if(res.code === 1) {
                            that.winrate = res.data.rate
                            that.setlinewidth()
                        }
                    })
            },
            updateListDyStatus(){
                let that = this
                let c = that.match
                if(c) {
                    if (c.tjtype === 2) {
                        if (c.ksykdy) {
                            c.sytime = c.sytime - 1
                            if (c.sytime <= 0) {
                                c.tjtype = 3
                            }
                            c.sytime_text = that.$formatSeconds(c.sytime)
                            // that.times = that.$formatSeconds(c.sytime).replace(':', '').replace(':', '').split('')
                        }else{
                            c.sytime_text = '-'
                        }
                    }
                    else{
                        c.sytime_text = '00:00:00'
                    }
                }
                // console.log(that.$formatSeconds(c.sytime).split(':'))
            },
            setlinewidth(){
                /**
                 * 设置胜率进度条长度
                 * @type {default.methods}
                 */
                let that = this
                setTimeout(function () {
                    that.$nextTick(() => {
                        let line = that.$refs.line
                        let width = 0
                        line.forEach((item) => {
                            width = item.offsetWidth
                        })
                        //更新胜率滚动条长度
                        let list = that.winrate
                        list.forEach(function (i) {
                            let w = parseInt(i.sl/100 * width)
                            if(i.sl<60)
                                i.width = 'width:'+ w +'px;background-color:#666;'
                            else
                                i.width = 'width:'+ w +'px'
                        })
                    })
                }, 1)
            },
            toTreaty(){
                this.$store.commit('SHOW_TREATY')
            },
            toMianze(){
                this.$store.commit('SHOW_MIANZE')
            },
        },
        beforeDestroy() {
            clearInterval(this.timer)
            this.timer = null
        },
        mounted() {
            let that = this
            that.timer = setInterval(()=>{
                that.updateListDyStatus() //定时更新订阅剩余时间
            }, 1000)
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                // console.log(form.path)
                // console.log(vm.formPath)
                if(to.meta.path !== undefined)
                    vm.formPath = to.meta.path
                else
                    vm.formPath = form.path === '/' ?'/ball':''
            })
        }
    }
</script>

<style scoped>
    .detail-main-free{min-height: calc(100vh - 66px) !important;background-color: #fff;position: relative;}
    /*.detail-main-free .det-tips{position: absolute;left:0;bottom:20px;width:100%;}*/
</style>
